(function(){
    'use strict';

    angular
        .module('elogbooks.admin.missed-patrol-reasons')
        .controller('MissedPatrolReasonController', MissedPatrolReasonController);

    function MissedPatrolReasonController($state, $stateParams, reasonCollectionResponse) {
        var vm = this;
        vm.reasonCollectionResponse = reasonCollectionResponse;
        vm.reasons = reasonCollectionResponse.reasons;
        vm.order = order;
        vm.search = search;

        vm.criteria = {
            id: { type: 'number', title: 'ID', value: $stateParams.id ? parseInt($stateParams.id, 10) : null, min: 1 },
            name: { type: 'text', title: 'NAME', value: $stateParams.name }
        };

        function order (key) {
            $stateParams.order = key;

            $state.go('.', angular.extend({}, $stateParams), { reload: true });
        }

        function search (params) {
            var override = {
                page: 1
            };

            $state.go('.', angular.extend({}, params, override), { reload: true });
        }
    }
})();
